import { AvailabilityRepository } from '@/core/availability/domain/AvailabilityRepository.ts'
import {
  WorkshopAvailability,
  WorkshopAvailabilityRequest
} from '@/core/availability/domain/Availability.ts'

type GetAvailabilityUseCaseDependencies = { availabilityRepository: AvailabilityRepository }

export class GetAvailabilityUseCase {
  private readonly availabilityRepository: AvailabilityRepository
  constructor({ availabilityRepository }: GetAvailabilityUseCaseDependencies) {
    this.availabilityRepository = availabilityRepository
  }

  execute = (requestData: WorkshopAvailabilityRequest): Promise<WorkshopAvailability> => {
    return this.availabilityRepository.getWorkshopAvailability(requestData)
  }
}
